export const SELECTED_COUNTRIES = ['United States', 'Canada'];

export const COUNTRIES = [
    { key: 'Afghanistan', value: 'Afghanistan' },
    { key: 'Åland Islands', value: 'Åland Islands' },
    { key: 'Albania', value: 'Albania' },
    { key: 'Algeria', value: 'Algeria' },
    { key: 'American Samoa', value: 'American Samoa' },
    { key: 'Andorra', value: 'Andorra' },
    { key: 'Angola', value: 'Angola' },
    { key: 'Anguilla', value: 'Anguilla' },
    { key: 'Antarctica', value: 'Antarctica' },
    { key: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
    { key: 'Argentina', value: 'Argentina' },
    { key: 'Armenia', value: 'Armenia' },
    { key: 'Aruba', value: 'Aruba' },
    { key: 'Australia', value: 'Australia' },
    { key: 'Austria', value: 'Austria' },
    { key: 'Azerbaijan', value: 'Azerbaijan' },
    { key: 'Bahamas', value: 'Bahamas' },
    { key: 'Bahrain', value: 'Bahrain' },
    { key: 'Bangladesh', value: 'Bangladesh' },
    { key: 'Barbados', value: 'Barbados' },
    { key: 'Belarus', value: 'Belarus' },
    { key: 'Belgium', value: 'Belgium' },
    { key: 'Belize', value: 'Belize' },
    { key: 'Benin', value: 'Benin' },
    { key: 'Bermuda', value: 'Bermuda' },
    { key: 'Bhutan', value: 'Bhutan' },
    { key: 'Bolivia', value: 'Bolivia' },
    { key: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
    { key: 'Botswana', value: 'Botswana' },
    { key: 'Bouvet Island', value: 'Bouvet Island' },
    { key: 'Brazil', value: 'Brazil' },
    { key: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory' },
    { key: 'Brunei Darussalam', value: 'Brunei Darussalam' },
    { key: 'Bulgaria', value: 'Bulgaria' },
    { key: 'Burkina Faso', value: 'Burkina Faso' },
    { key: 'Burundi', value: 'Burundi' },
    { key: 'Cambodia', value: 'Cambodia' },
    { key: 'Cameroon', value: 'Cameroon' },
    { key: 'Canada', value: 'Canada' },
    { key: 'Cape Verde', value: 'Cape Verde' },
    { key: 'Cayman Islands', value: 'Cayman Islands' },
    { key: 'Central African Republic', value: 'Central African Republic' },
    { key: 'Chad', value: 'Chad' },
    { key: 'Chile', value: 'Chile' },
    { key: 'China', value: 'China' },
    { key: 'Christmas Island', value: 'Christmas Island' },
    { key: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands' },
    { key: 'Colombia', value: 'Colombia' },
    { key: 'Comoros', value: 'Comoros' },
    { key: 'Congo', value: 'Congo' },
    { key: 'Congo, The Democratic Republic of The', value: 'Congo, The Democratic Republic of The' },
    { key: 'Cook Islands', value: 'Cook Islands' },
    { key: 'Costa Rica', value: 'Costa Rica' },
    { key: 'Cote D\'ivoire', value: 'Cote D\'ivoire' },
    { key: 'Croatia', value: 'Croatia' },
    { key: 'Cuba', value: 'Cuba' },
    { key: 'Cyprus', value: 'Cyprus' },
    { key: 'Czech Republic', value: 'Czech Republic' },
    { key: 'Denmark', value: 'Denmark' },
    { key: 'Djibouti', value: 'Djibouti' },
    { key: 'Dominica', value: 'Dominica' },
    { key: 'Dominican Republic', value: 'Dominican Republic' },
    { key: 'Ecuador', value: 'Ecuador' },
    { key: 'Egypt', value: 'Egypt' },
    { key: 'El Salvador', value: 'El Salvador' },
    { key: 'Equatorial Guinea', value: 'Equatorial Guinea' },
    { key: 'Estonia', value: 'Estonia' },
    { key: 'Eritrea', value: 'Eritrea' },
    { key: 'Ethiopia', value: 'Ethiopia' },
    { key: 'Falkland Islands (Malvinas)', value: 'Falkland Islands (Malvinas)' },
    { key: 'Faroe Islands', value: 'Faroe Islands' },
    { key: 'Fiji', value: 'Fiji' },
    { key: 'Finland', value: 'Finland' },
    { key: 'France', value: 'France' },
    { key: 'French Guiana', value: 'French Guiana' },
    { key: 'French Polynesia', value: 'French Polynesia' },
    { key: 'French Southern Territories', value: 'French Southern Territories' },
    { key: 'Gabon', value: 'Gabon' },
    { key: 'Gambia', value: 'Gambia' },
    { key: 'Georgia', value: 'Georgia' },
    { key: 'Germany', value: 'Germany' },
    { key: 'Ghana', value: 'Ghana' },
    { key: 'Gibraltar', value: 'Gibraltar' },
    { key: 'Greece', value: 'Greece' },
    { key: 'Greenland', value: 'Greenland' },
    { key: 'Grenada', value: 'Grenada' },
    { key: 'Guadeloupe', value: 'Guadeloupe' },
    { key: 'Guam', value: 'Guam' },
    { key: 'Guatemala', value: 'Guatemala' },
    { key: 'Guernsey', value: 'Guernsey' },
    { key: 'Guinea', value: 'Guinea' },
    { key: 'Guinea-bissau', value: 'Guinea-bissau' },
    { key: 'Guyana', value: 'Guyana' },
    { key: 'Haiti', value: 'Haiti' },
    { key: 'Heard Island and Mcdonald Islands', value: 'Heard Island and Mcdonald Islands' },
    { key: 'Holy See (Vatican City State)', value: 'Holy See (Vatican City State)' },
    { key: 'Honduras', value: 'Honduras' },
    { key: 'Hong Kong', value: 'Hong Kong' },
    { key: 'Hungary', value: 'Hungary' },
    { key: 'Iceland', value: 'Iceland' },
    { key: 'India', value: 'India' },
    { key: 'Indonesia', value: 'Indonesia' },
    { key: 'Iran, Islamic Republic of', value: 'Iran, Islamic Republic of' },
    { key: 'Iraq', value: 'Iraq' },
    { key: 'Ireland', value: 'Ireland' },
    { key: 'Isle of Man', value: 'Isle of Man' },
    { key: 'Israel', value: 'Israel' },
    { key: 'Italy', value: 'Italy' },
    { key: 'Jamaica', value: 'Jamaica' },
    { key: 'Japan', value: 'Japan' },
    { key: 'Jersey', value: 'Jersey' },
    { key: 'Jordan', value: 'Jordan' },
    { key: 'Kazakhstan', value: 'Kazakhstan' },
    { key: 'Kenya', value: 'Kenya' },
    { key: 'Kiribati', value: 'Kiribati' },
    { key: 'Korea, Democratic People\'s Republic of', value: 'Korea, Democratic People\'s Republic of' },
    { key: 'Korea, Republic of', value: 'Korea, Republic of' },
    { key: 'Kuwait', value: 'Kuwait' },
    { key: 'Kyrgyzstan', value: 'Kyrgyzstan' },
    { key: 'Lao People\'s Democratic Republic', value: 'Lao People\'s Democratic Republic' },
    { key: 'Latvia', value: 'Latvia' },
    { key: 'Lebanon', value: 'Lebanon' },
    { key: 'Lesotho', value: 'Lesotho' },
    { key: 'Liberia', value: 'Liberia' },
    { key: 'Libyan Arab Jamahiriya', value: 'Libyan Arab Jamahiriya' },
    { key: 'Liechtenstein', value: 'Liechtenstein' },
    { key: 'Lithuania', value: 'Lithuania' },
    { key: 'Luxembourg', value: 'Luxembourg' },
    { key: 'Macao', value: 'Macao' },
    { key: 'Macedonia, The Former Yugoslav Republic of', value: 'Macedonia, The Former Yugoslav Republic of' },
    { key: 'Madagascar', value: 'Madagascar' },
    { key: 'Malawi', value: 'Malawi' },
    { key: 'Malaysia', value: 'Malaysia' },
    { key: 'Maldives', value: 'Maldives' },
    { key: 'Mali', value: 'Mali' },
    { key: 'Malta', value: 'Malta' },
    { key: 'Marshall Islands', value: 'Marshall Islands' },
    { key: 'Martinique', value: 'Martinique' },
    { key: 'Mauritania', value: 'Mauritania' },
    { key: 'Mauritius', value: 'Mauritius' },
    { key: 'Mayotte', value: 'Mayotte' },
    { key: 'Mexico', value: 'Mexico' },
    { key: 'Micronesia, Federated States of', value: 'Micronesia, Federated States of' },
    { key: 'Moldova, Republic of', value: 'Moldova, Republic of' },
    { key: 'Monaco', value: 'Monaco' },
    { key: 'Mongolia', value: 'Mongolia' },
    { key: 'Montenegro', value: 'Montenegro' },
    { key: 'Montserrat', value: 'Montserrat' },
    { key: 'Morocco', value: 'Morocco' },
    { key: 'Mozambique', value: 'Mozambique' },
    { key: 'Myanmar', value: 'Myanmar' },
    { key: 'Namibia', value: 'Namibia' },
    { key: 'Nauru', value: 'Nauru' },
    { key: 'Nepal', value: 'Nepal' },
    { key: 'Netherlands', value: 'Netherlands' },
    { key: 'Netherlands Antilles', value: 'Netherlands Antilles' },
    { key: 'New Caledonia', value: 'New Caledonia' },
    { key: 'New Zealand', value: 'New Zealand' },
    { key: 'Nicaragua', value: 'Nicaragua' },
    { key: 'Niger', value: 'Niger' },
    { key: 'Nigeria', value: 'Nigeria' },
    { key: 'Niue', value: 'Niue' },
    { key: 'Norfolk Island', value: 'Norfolk Island' },
    { key: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
    { key: 'Norway', value: 'Norway' },
    { key: 'Oman', value: 'Oman' },
    { key: 'Pakistan', value: 'Pakistan' },
    { key: 'Palau', value: 'Palau' },
    { key: 'Palestinian Territory, Occupied', value: 'Palestinian Territory, Occupied' },
    { key: 'Panama', value: 'Panama' },
    { key: 'Papua New Guinea', value: 'Papua New Guinea' },
    { key: 'Paraguay', value: 'Paraguay' },
    { key: 'Peru', value: 'Peru' },
    { key: 'Philippines', value: 'Philippines' },
    { key: 'Pitcairn', value: 'Pitcairn' },
    { key: 'Poland', value: 'Poland' },
    { key: 'Portugal', value: 'Portugal' },
    { key: 'Puerto Rico', value: 'Puerto Rico' },
    { key: 'Qatar', value: 'Qatar' },
    { key: 'Reunion', value: 'Reunion' },
    { key: 'Romania', value: 'Romania' },
    { key: 'Russian Federation', value: 'Russian Federation' },
    { key: 'Rwanda', value: 'Rwanda' },
    { key: 'Saint Helena', value: 'Saint Helena' },
    { key: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
    { key: 'Saint Lucia', value: 'Saint Lucia' },
    { key: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon' },
    { key: 'Saint Vincent and The Grenadines', value: 'Saint Vincent and The Grenadines' },
    { key: 'Samoa', value: 'Samoa' },
    { key: 'San Marino', value: 'San Marino' },
    { key: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
    { key: 'Saudi Arabia', value: 'Saudi Arabia' },
    { key: 'Senegal', value: 'Senegal' },
    { key: 'Serbia', value: 'Serbia' },
    { key: 'Seychelles', value: 'Seychelles' },
    { key: 'Sierra Leone', value: 'Sierra Leone' },
    { key: 'Singapore', value: 'Singapore' },
    { key: 'Slovakia', value: 'Slovakia' },
    { key: 'Slovenia', value: 'Slovenia' },
    { key: 'Solomon Islands', value: 'Solomon Islands' },
    { key: 'Somalia', value: 'Somalia' },
    { key: 'South Africa', value: 'South Africa' },
    { key: 'South Georgia and The South Sandwich Islands', value: 'South Georgia and The South Sandwich Islands' },
    { key: 'Spain', value: 'Spain' },
    { key: 'Sri Lanka', value: 'Sri Lanka' },
    { key: 'Sudan', value: 'Sudan' },
    { key: 'Suriname', value: 'Suriname' },
    { key: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' },
    { key: 'Swaziland', value: 'Swaziland' },
    { key: 'Sweden', value: 'Sweden' },
    { key: 'Switzerland', value: 'Switzerland' },
    { key: 'Syrian Arab Republic', value: 'Syrian Arab Republic' },
    { key: 'Taiwan, Province of China', value: 'Taiwan, Province of China' },
    { key: 'Tajikistan', value: 'Tajikistan' },
    { key: 'Tanzania, United Republic of', value: 'Tanzania, United Republic of' },
    { key: 'Thailand', value: 'Thailand ' },
    { key: 'Timor-leste', value: 'Timor-leste' },
    { key: 'Togo', value: 'Togo' },
    { key: 'Tokelau', value: 'Tokelau' },
    { key: 'Tonga', value: 'Tonga' },
    { key: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
    { key: 'Tunisia', value: 'Tunisia' },
    { key: 'Turkey', value: 'Turkey' },
    { key: 'Turkmenistan', value: 'Turkmenistan' },
    { key: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' },
    { key: 'Tuvalu', value: 'Tuvalu' },
    { key: 'Uganda', value: 'Uganda' },
    { key: 'Ukraine', value: 'Ukraine' },
    { key: 'United Arab Emirates', value: 'United Arab Emirates' },
    { key: 'United Kingdom', value: 'United Kingdom' },
    { key: 'United States', value: 'United States of America' },
    { key: 'United States Minor Outlying Islands', value: 'United States Minor Outlying Islands' },
    { key: 'Uruguay', value: 'Uruguay' },
    { key: 'Uzbekistan', value: 'Uzbekistan' },
    { key: 'Vanuatu', value: 'Vanuatu' },
    { key: 'Venezuela', value: 'Venezuela' },
    { key: 'Viet Nam', value: 'Viet Nam' },
    { key: 'Virgin Islands, British', value: 'Virgin Islands, British' },
    { key: 'Virgin Islands, U.S.', value: 'Virgin Islands, U.S.' },
    { key: 'Wallis and Futuna', value: 'Wallis and Futuna' },
    { key: 'Western Sahara', value: 'Western Sahara' },
    { key: 'Yemen', value: 'Yemen' },
    { key: 'Zambia', value: 'Zambia' },
    { key: 'Zimbabwe', value: 'Zimbabwe' }
];

export const AMERICAN_STATES = [
    { key: "AK", value: 'Alaska' },
    { key: "AL", value: 'Alabama' },
    { key: "AR", value: 'Arkansas' },
    { key: "AZ", value: 'Arizona' },
    { key: "CA", value: 'California' },
    { key: "CO", value: 'Colorado' },
    { key: "CT", value: 'Connecticut' },
    { key: "DC", value: 'District of Columbia' },
    { key: "DE", value: 'Delaware' },
    { key: "FL", value: 'Florida' },
    { key: "GA", value: 'Georgia' },
    { key: "HI", value: 'Hawaii' },
    { key: "IA", value: 'Iowa' },
    { key: "ID", value: 'Idaho' },
    { key: "IL", value: 'Illinois' },
    { key: "IN", value: 'Indiana' },
    { key: "KS", value: 'Kansas' },
    { key: "KY", value: 'Kentucky' },
    { key: "LA", value: 'Louisiana' },
    { key: "MA", value: 'Massachusetts' },
    { key: "MD", value: 'Maryland' },
    { key: "ME", value: 'Maine' },
    { key: "MI", value: 'Michigan' },
    { key: "MN", value: 'Minnesota' },
    { key: "MO", value: 'Missouri' },
    { key: "MS", value: 'Mississippi' },
    { key: "MT", value: 'Montana ' },
    { key: "NC", value: 'North Carolina' },
    { key: "ND", value: 'North Dakota' },
    { key: "NE", value: 'Nebraska' },
    { key: "NH", value: 'New Hampshire' },
    { key: "NJ", value: 'New Jersey' },
    { key: "NM", value: 'New Mexico' },
    { key: "NV", value: 'Nevada' },
    { key: "NY", value: 'New York' },
    { key: "OH", value: 'Ohio' },
    { key: "OK", value: 'Oklahoma ' },
    { key: "OR", value: 'Oregon' },
    { key: "PA", value: 'Pennsylvania ' },
    { key: "PR", value: 'Puerto Rico' },
    { key: "RI", value: 'Rhode Island' },
    { key: "SC", value: 'South Carolina' },
    { key: "SD", value: 'South Dakota ' },
    { key: "TN", value: 'Tennessee' },
    { key: "TX", value: 'Texas' },
    { key: "UT", value: 'Utah' },
    { key: "VA", value: 'Virginia' },
    { key: "VT", value: 'Vermont' },
    { key: "WA", value: 'Washington' },
    { key: "WI", value: 'Wisconsin' },
    { key: "WV", value: 'West Virginia' },
    { key: "WY", value: 'Wyoming' },
];

export const CANADIAN_STATES = [
    { key: "AB", value: 'Alberta' },
    { key: "BC", value: 'British Columbia' },
    { key: "MB", value: 'Manitoba' },
    { key: "NB", value: 'New Brunswick' },
    { key: "NF", value: 'Newfoundland' },
    { key: "NT", value: 'Northwest Territories' },
    { key: "NS", value: 'Nova Scotia' },
    { key: "NU", value: 'Nunavut' },
    { key: "ON", value: 'Ontario' },
    { key: "PE", value: 'Prince Edward Island' },
    { key: "QC", value: 'Quebec' },
    { key: "SK", value: 'Saskatchewan' },
    { key: "YT", value: 'Yukon Territory' },
];

export const COUNTRIES_CODES = [1, 44, 31, 45, 33, 49, 61, 972, 41, 64, 39, 46, 55, 7, 20, 27, 30, 32, 34, 36, 40, 43, 47, 48, 51, 52, 54, 56, 57, 58, 60, 62, 63, 65, 66, 81, 82, 84, 86, 90, 91, 92, 94, 212, 213, 216, 218, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 248, 250, 251, 252, 253, 254, 255, 256, 257, 258, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 290, 291, 297, 298, 299, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 370, 371, 372, 373, 374, 375, 376, 377, 378, 380, 381, 385, 386, 387, 389, 420, 421, 423, 500, 501, 502, 503, 504, 505, 506, 507, 508, 509, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 670, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 685, 686, 687, 688, 689, 690, 691, 692, 852, 853, 855, 856, 880, 886, 960, 961, 962, 963, 964, 965, 966, 967, 968, 971, 973, 974, 975, 976, 977, 992, 993, 994, 995, 996, 998];

export const COUNTRIES_DIAL_CODES = {
    Afghanistan: '+93',
    Albania: '+355',
    Algeria: '+213',
    AmericanSamoa: '+1 684',
    Andorra: '+376',
    Angola: '+244',
    Anguilla: '+1 264',
    Antarctica: '+672',
    'Antigua and Barbuda': '+1268',
    Argentina: '+54',
    Armenia: '+374',
    Aruba: '+297',
    Australia: '+61',
    Austria: '+43',
    Azerbaijan: '+994',
    Bahamas: '+1 242',
    Bahrain: '+973',
    Bangladesh: '+880',
    Barbados: '+1 246',
    Belarus: '+375',
    Belgium: '+32',
    Belize: '+501',
    Benin: '+229',
    Bermuda: '+1 441',
    Bhutan: '+975',
    'Bolivia, Plurinational State of Bolivia': '+591',
    'Bosnia and Herzegovina': '+387',
    Botswana: '+267',
    'Bouvet Island': '+55',
    Brazil: '+55',
    'British Indian Ocean Territory': '+246',
    'Brunei Darussalam': '+673',
    Bulgaria: '+359',
    'Burkina Faso': '+226',
    Burundi: '+257',
    Cambodia: '+855',
    Cameroon: '+237',
    Canada: '+1',
    'Cape Verde': '+238',
    'Cayman Islands': '+1345',
    'Central African Republic': '+236',
    Chad: '+235',
    Chile: '+56',
    China: '+86',
    'Christmas Island': '+61',
    'Cocos (Keeling) Islands': '+61',
    Colombia: '+57',
    Comoros: '+269',
    Congo: '+242',
    'Congo, The Democratic Republic of the': '+243',
    'Cook Islands': '+682',
    'Costa Rica': '+506',
    "Cote d'Ivoire": '+225',
    Croatia: '+385',
    Cuba: '+53',
    Cyprus: '+357',
    'Czech Republic': '+420',
    Denmark: '+45',
    Djibouti: '+253',
    Dominica: '+1 767',
    'Dominican Republic': '+1 849',
    Ecuador: '+593',
    Egypt: '+20',
    'El Salvador': '+503',
    'Equatorial Guinea': '+240',
    Eritrea: '+291',
    Estonia: '+372',
    Ethiopia: '+251',
    'Falkland Islands (Malvinas)': '+500',
    'Faroe Islands': '+298',
    Fiji: '+679',
    Finland: '+358',
    France: '+33',
    'French Guiana': '+594',
    'French Polynesia': '+689',
    'French Southern and Antarctic Lands': '+262',
    Gabon: '+241',
    Gambia: '+220',
    Georgia: '+995',
    Germany: '+49',
    Ghana: '+233',
    Gibraltar: '+350',
    Greece: '+30',
    Greenland: '+299',
    Grenada: '+1 473',
    Guadeloupe: '+590',
    Guam: '+1 671',
    Guatemala: '+502',
    Guernsey: '+44',
    Guinea: '+224',
    'Guinea-Bissau': '+245',
    Guyana: '+592',
    Haiti: '+509',
    'Heard Island and McDonald Islands': '+672',
    'Holy See (Vatican City State)': '+379',
    Honduras: '+504',
    'Hong Kong': '+852',
    Hungary: '+36',
    Iceland: '+354',
    India: '+91',
    Indonesia: '+62',
    'Iran, Islamic Republic of': '+98',
    Iraq: '+964',
    Ireland: '+353',
    'Isle of Man': '+44',
    Israel: '+972',
    Italy: '+39',
    Jamaica: '+1 876',
    Japan: '+81',
    Jersey: '+44',
    Jordan: '+962',
    Kazakhstan: '+7',
    Kenya: '+254',
    Kiribati: '+686',
    "Korea, Democratic People's Republic of": '+850',
    'Korea, Republic of': '+82',
    Kuwait: '+965',
    Kyrgyzstan: '+996',
    "Lao People's Democratic Republic": '+856',
    Latvia: '+371',
    Lebanon: '+961',
    Lesotho: '+266',
    Liberia: '+231',
    'Libyan Arab Jamahiriya': '+218',
    Liechtenstein: '+423',
    Lithuania: '+370',
    Luxembourg: '+352',
    Macao: '+853',
    'Macedonia, The Former Yugoslav Republic of': '+389',
    Madagascar: '+261',
    Malawi: '+265',
    Malaysia: '+60',
    Maldives: '+960',
    Mali: '+223',
    Malta: '+356',
    'Marshall Islands': '+692',
    Martinique: '+596',
    Mauritania: '+222',
    Mauritius: '+230',
    Mayotte: '+262',
    Mexico: '+52',
    'Micronesia, Federated States of': '+691',
    'Moldova, Republic of': '+373',
    Monaco: '+377',
    Mongolia: '+976',
    Montenegro: '+382',
    Montserrat: '+1664',
    Morocco: '+212',
    Mozambique: '+258',
    Myanmar: '+95',
    Namibia: '+264',
    Nauru: '+674',
    Nepal: '+977',
    Netherlands: '+31',
    'Netherlands Antilles': '+599',
    'New Caledonia': '+687',
    'New Zealand': '+64',
    Nicaragua: '+505',
    Niger: '+227',
    Nigeria: '+234',
    Niue: '+683',
    'Norfolk Island': '+672',
    'Northern Mariana Islands': '+1 670',
    Norway: '+47',
    Oman: '+968',
    Pakistan: '+92',
    Palau: '+680',
    'Palestinian Territory, Occupied': '+970',
    Panama: '+507',
    'Papua New Guinea': '+675',
    Paraguay: '+595',
    Peru: '+51',
    Philippines: '+63',
    Pitcairn: '+870',
    Poland: '+48',
    Portugal: '+351',
    'Puerto Rico': '+1 939',
    Qatar: '+974',
    'Réunion': '+262',
    Romania: '+40',
    Russia: '+7',
    Rwanda: '+250',
    'Saint Helena, Ascension and Tristan Da Cunha': '+290',
    'Saint Kitts and Nevis': '+1 869',
    'Saint Lucia': '+1 758',
    'Saint Pierre and Miquelon': '+508',
    'Saint Vincent and the Grenadines': '+1 784',
    Samoa: '+685',
    'San Marino': '+378',
    'Sao Tome and Principe': '+239',
    'Saudi Arabia': '+966',
    Senegal: '+221',
    Serbia: '+381',
    Seychelles: '+248',
    'Sierra Leone': '+232',
    Singapore: '+65',
    Slovakia: '+421',
    Slovenia: '+386',
    'Solomon Islands': '+677',
    Somalia: '+252',
    'South Africa': '+27',
    'South Georgia and the South Sandwich Islands': '+500',
    Spain: '+34',
    'Sri Lanka': '+94',
    Sudan: '+249',
    Suriname: '+597',
    'Svalbard and Jan Mayen': '+47',
    Eswatini: '+268',
    Sweden: '+46',
    Switzerland: '+41',
    'Syrian Arab Republic': '+963',
    Taiwan: '+886',
    Tajikistan: '+992',
    'Tanzania, United Republic of': '+255',
    Thailand: '+66',
    'Timor-Leste': '+670',
    Togo: '+228',
    Tokelau: '+690',
    Tonga: '+676',
    'Trinidad and Tobago': '+1 868',
    Tunisia: '+216',
    Turkey: '+90',
    Turkmenistan: '+993',
    'Turks and Caicos Islands': '+1 649',
    Tuvalu: '+688',
    Uganda: '+256',
    Ukraine: '+380',
    'United Arab Emirates': '+971',
    'United Kingdom': '+44',
    'United States': '+1',
    'United States Minor Outlying Islands': '+1581',
    Uruguay: '+598',
    Uzbekistan: '+998',
    Vanuatu: '+678',
    'Venezuela, Bolivarian Republic of': '+58',
    'Viet Nam': '+84',
    'Virgin Islands, British': '+1 284',
    'Virgin Islands, U.S.': '+1 340',
    'Wallis and Futuna': '+681',
    'Western Sahara': '+732',
    Yemen: '+967',
    Zambia: '+260',
    Zimbabwe: '+263'
};

export const COUNTRIES_CODE_LENGTH = {
Afghanistan:7,
Albania:7,
Algeria:6,
Andorra:3,
Angola:6,
AntiguaandBarbuda:7,
Argentina:8,
Armenia:6,
Australia:7,
Austria:7,
Azerbaijan:7,
Bahamas:7,
Bahrain:7,
Bangladesh:8,
Barbados:7,
Belarus:7,
Belgium:6,
Belize:4,
Benin:6,
Bhutan:6,
Bolivia:8,
BosniaandHerzegovina:6,
Botswana:6,
Brazil:8,
Brunei:7,
Bulgaria:7,
BurkinaFaso:6,
Burundi:6,
CaboVerde:4,
Cambodia:7,
Cameroon:7,
Canada:7,
CentralAfricanRepublic:6,
Chad:6,
Chile:8,
China:8,
Colombia:8,
Comoros:4,
'Congo(Congo-Brazzaville)':6,
'Congo(DemocraticRepublic)':7,
CostaRica:7,
Croatia:7,
Cuba:7,
Cyprus:6,
CzechRepublic:7,
Denmark:6,
Djibouti:6,
Dominica:7,
DominicanRepublic:7,
Ecuador:7,
Egypt:7,
ElSalvador:7,
EquatorialGuinea:6,
Eritrea:6,
Estonia:6,
Eswatini:6,
Ethiopia:7,
Fiji:4,
Finland:7,
France:8,
Gabon:7,
Gambia:7,
Germany:7,
Ghana:7,
Greece:7,
Grenada:7,
Guatemala:7,
Guinea:6,
'Guinea-Bissau':6,
Guyana:7,
Haiti:7,
Honduras:7,
Hungary:7,
Iceland:6,
India:5,
Indonesia:8,
Iran:7,
Iraq:7,
Ireland:7,
Israel:7,
Italy:7,
Jamaica:7,
Japan:8,
Jordan:7,
Kazakhstan:7,
Kenya:6,
Kiribati:7,
'Korea(North)':7,
'Korea(South)':8,
Kuwait:8,
Kyrgyzstan:7,
Laos:7,
Latvia:5,
Lebanon:6,
Lesotho:7,
Liberia:7,
Libya:7,
Liechtenstein:3,
Lithuania:5,
Luxembourg:6,
Madagascar:7,
Malawi:7,
Malaysia:8,
Maldives:4,
Mali:6,
Malta:6,
MarshallIslands:7,
Mauritania:6,
Mauritius:7,
Mexico:8,
Micronesia:7,
Moldova:6,
Monaco:6,
Mongolia:7,
Montenegro:6,
Morocco:6,
Mozambique:7,
Myanmar:9,
Namibia:7,
Nauru:7,
Nepal:7,
Netherlands:8,
NewZealand:7,
Nicaragua:7,
Niger:6,
Nigeria:7,
NorthMacedonia:6,
Norway:6,
Oman:7,
Pakistan:7,
Palau:7,
Panama:7,
PapuaNewGuinea:7,
Paraguay:7,
Peru:7,
Philippines:8,
Poland:6,
Portugal:7,
Qatar:7,
Romania:7,
Russia:7,
Rwanda:7,
SaintKittsandNevis:7,
SaintLucia:7,
SaintVincentandtheGrenadines:7,
Samoa:7,
SanMarino:3,
SaoTomeandPrincipe:4,
SaudiArabia:7,
Senegal:7,
Serbia:7,
Seychelles:7,
SierraLeone:6,
Singapore:8,
Slovakia:7,
Slovenia:7,
SolomonIslands:7,
Somalia:7,
SouthAfrica:7,
SouthSudan:7,
Spain:9,
SriLanka:8,
Sudan:7,
Suriname:7,
Sweden:8,
Switzerland:7,
Syria:7,
Taiwan:8,
Tajikistan:7,
Tanzania:7,
Thailand:8,
'Timor-Leste':7,
Togo:6,
Tonga:7,
TrinidadandTobago:7,
Tunisia:8,
Turkey:8,
Turkmenistan:7,
Tuvalu:7,
Uganda:7,
Ukraine:7,
UnitedArabEmirates:7,
UnitedKingdom:9,
UnitedStates:10,
Uruguay:8,
Uzbekistan:7,
Vanuatu:7,
VaticanCity:3,
Venezuela:7,
Vietnam:8,
Yemen:7,
Zambia:7,
Zimbabwe:7
}


export const COUNTRY_LAST_PHONE_LENGTH = {
'+1': 7,
'+44': 8,
'+92': 7,
'+91': 7,
'+61': 8,
'+81': 8,
'+49': 7,
'+33': 9,
'+39': 8,
'+46': 7,
'+55': 8,
'+7': 7,
'+20': 7,
'+27': 9,
'+30': 7,
'+31':8,
'+32': 8,
'+34': 7,
'+36': 7,
'+40': 7,
'+43': 7,
'+47': 8,
'+48': 7,
'+51': 7,
'+52': 7,
'+54': 7,
'+56': 7,
'+57': 7,
'+58': 7,
'+60': 8,
'+62': 8,
'+63': 7,
'+65': 7,
'+66': 8,
'+82': 8,
'+84': 8,
'+86': 8,
'+90': 8,
'+94': 7,
'+212': 7,
'+213': 7,
'+216': 7,
'+218': 7,
'+220': 7,
'+221': 7,
'+222': 7,
'+223': 7,
'+224': 7,
'+225': 7,
'+226': 7,
'+227': 7,
'+228': 7,
'+229': 7,
'+230': 7,
'+231': 7,
'+232': 7,
'+233': 7,
'+234': 7,
'+235': 7,
'+236': 7,
'+237': 7,
'+238': 7,
'+239': 7,
'+240': 7,
'+241': 7,
'+242': 7,
'+243': 7,
'+244': 7,
'+245': 7,
'+248': 7,
'+250': 7,
'+251': 7,
'+252': 7,
'+253': 7,
'+254': 7,
'+255': 7,
'+256': 7,
'+257': 7,
'+258': 7,
'+260': 7,
'+261': 7,
'+262': 7,
'+263': 7,
'+264': 7,
'+265': 7,
'+266': 7,
'+267': 7,
'+268': 7,
'+269': 7,
'+290': 7,
'+291': 7,
'+297': 7,
'+298': 7,
'+299': 7,
'+350': 7,
'+351': 7,
'+352': 7,
'+353': 7,
'+354': 7,
'+355': 7,
'+356': 7,
'+357': 7,
'+358': 7,
'+359': 7,
'+370': 7,
'+371': 7,
'+372': 7,
'+373': 7,
'+374': 7,
'+375': 7,
'+376': 7,
'+377': 7,
'+378': 7,
'+380': 7,
'+381': 7,
'+385': 7,
'+386': 7,
'+387': 7,
'+389': 7,
'+420': 7,
'+421': 7,
'+423': 7,
'+500': 7,
'+501': 7,
'+502': 7,
'+503': 7,
'+504': 7,
'+505': 7,
'+506': 7,
'+507': 7,
'+508': 7,
'+509': 7,
'+590': 7,
'+591': 7,
'+592': 7,
'+593': 7,
'+594': 7,
'+595': 7,
'+596': 7,
'+597': 7,
'+598': 7,
'+599': 7,
'+670': 7,
'+672': 7,
'+673': 7,
'+674': 7,
'+675': 7,
'+676': 7,
'+677': 7,
'+678': 7,
'+679': 7,
'+680': 7,
'+681': 7,
'+682': 7,
'+683': 7,
'+685': 7,
'+686': 7,
'+687': 7,
'+688': 7,
'+689': 7,
'+690': 7,
'+691': 7,
'+692': 7,
'+852': 7,
'+853': 7,
'+855': 7,
'+856': 7,
'+880': 7,
'+886': 7,
'+960': 7,
'+961': 7,
'+962': 7,
'+963': 7,
'+964': 7,
'+965': 7,
'+966': 7,
'+967': 7,
'+968': 7,
'+971': 7,
'+973': 7,
'+974': 7,
'+975': 7,
'+976': 7,
'+977': 7,
'+992': 7,
'+993': 7,
'+994': 7,
'+995': 7,
'+996': 7,
'+998': 7,
}